const TaskRelationship = React.memo(function TaskRelationship(props){
    const {
        allowMultiSelection,
        value,
        people,
        renderOptionsAs,
        groupOptionsBy,
        missingGroupValue,
        enableCollapsibleGroups,
        onChange,
    } = props;

    const change = React.useCallback((name, value) => {
        onChange(name, value);
    }, []);

    //useRenderDebug('TaskRelationship', {props});
    let style = {};
    let renderAs = 'radiogroup';
    if(renderOptionsAs === 'radio' && allowMultiSelection){
        renderAs = 'checkboxgroup';
    }
    if(renderOptionsAs === 'select' && !allowMultiSelection){
        renderAs = 'combo';
        style = {width: '100%', maxWidth: 400};
    }
    if(renderOptionsAs === 'select' && allowMultiSelection){
        renderAs = 'multiselect';
        style = {width: '100%', maxWidth: 400};
    }

    return (
        <div className={`processes-task-relationship flex-vertical`} style={style}>
            <TaskField
                type={'select'}
                renderAs={renderAs}
                groupPath={groupOptionsBy}
                missingGroupingValue={missingGroupValue}
                enableCollapsibleGroups={enableCollapsibleGroups}
                name={'secondary_person_id'}
                idPath={'Person.id'}
                displayPath={'Person._label'}
                required={true}
                value={value.secondary_person_id || ''}
                store={people}
                columns={1}
                autoFlexColumns={true}
                onChange={change}
            />
        </div>
    );
});

TaskRelationship.defaultProps = {
    allowMultiSelection: PropTypes.bool,
    value: PropTypes.any,
    people: PropTypes.array,
    renderOptionsAs: PropTypes.oneOf(['radio', 'select']),
    groupOptionsBy: PropTypes.string,
    missingGroupValue: PropTypes.string,
    enableCollapsibleGroups: PropTypes.bool,
    onChange: PropTypes.func,
};

TaskRelationship.defaultProps = {
    allowMultiSelection: false,
    value: {},
    people: [],
    renderOptionsAs: 'radio',
    groupOptionsBy: null,
    missingGroupValue: 'Unknown',
    enableCollapsibleGroups: false,
    onChange: (path, value) => {},
};
TaskRelationship.displayName = 'TaskRelationship';